/**
 * MYEM-250: Hilfen fuer den Link zur anonymen Sendungsverfolgung im neuen Tracking & Tracing.
 */

// Die T&T-Oberflaeche bietet de, en, fr, cs und pl an; myEmons erzeugt davon nur de, en und cs,
// weil es selbst keine weiteren Sprachen kennt. Slowakisch weicht auf Tschechisch aus
// (Entscheidung des Fachbereichs, 04.09.2026). Dieselbe Abbildung steht im Backend in
// ShipmentLinks.trackingLanguage() fuer die Benachrichtigungs-Mail.
const TRACKING_LANGUAGES = { de: 'de', en: 'en', cs: 'cs', sk: 'cs' }

export function trackingLanguage(locale) {
  const key = (locale || '').toLowerCase().substring(0, 2)
  return TRACKING_LANGUAGES[key] || 'de'
}

// Zustaende ab Freigabe (Backend: ShipmentState.isCommissioned())
const COMMISSIONED_STATES = ['FINALIZED', 'CARGO_LIST_CREATED', 'SHIPPING', 'SHIPPED']

/** Freigegeben, aber das T&T kennt die Sendung noch nicht: Nummer ohne Link, mit Tooltip. */
export function isTrackingPending(shipment) {
  return !!shipment
    && COMMISSIONED_STATES.includes(shipment.state)
    && !shipment.trackingAvailableSince
}
